export class StyleGroup {
	id?: number;
	name?: string;

	constructor(init?: Partial<StyleGroup>) {
		Object.assign(this, init);
	}
}
